import React from 'react';
import {
  CompanySsoConnectionTypePayload,
  ContentArrayPayload,
  UserPageCompanyInfo,
} from '../../../types/models';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { UrlToCompany } from '../../constants';
import LabelBox from '../../components/LabelBox';

interface CompanyInfoProps extends UserPageCompanyInfo {
  ssoConnectionTypes: ContentArrayPayload<CompanySsoConnectionTypePayload> | null;
}

export const CompanyInfo: React.FC<CompanyInfoProps> = props => {
  const {
    id,
    name,
    sso_connection,
    identity_provider_domains,
    ssoConnectionTypes,
  } = props;

  let sso_type: string | undefined = '';
  if (ssoConnectionTypes?.contents?.length) {
    sso_type = ssoConnectionTypes?.contents?.find(
      s => s.code === sso_connection,
    )?.label;
  }

  if (!id || id === '') {
    return (
      <Grid
        container
        spacing={0}
        style={{ justifyContent: 'start', fontSize: 17, color: '#b1b1b1' }}
      >
        No matching company found.
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item lg={4} xs={12}>
        <LabelBox>
          <Box color="text.secondary">
            <Typography variant="subtitle2">Company ID</Typography>
          </Box>
          <Link to={UrlToCompany(id).detail}>{id}</Link>
        </LabelBox>
        <LabelBox>
          <TextField
            name="sso_type"
            label="SSO Type"
            variant="outlined"
            value={sso_type}
            disabled
            fullWidth
          />
        </LabelBox>
      </Grid>
      <Grid item lg={4} xs={12}>
        <LabelBox>
          <TextField
            name="name"
            label="Company Name"
            variant="outlined"
            value={name}
            disabled
            fullWidth
          />
        </LabelBox>
        <LabelBox>
          <TextField
            name="identity_provider_domains"
            label="Customer Email (Provider) Domains"
            variant="outlined"
            value={identity_provider_domains}
            disabled
            fullWidth
          />
        </LabelBox>
      </Grid>
    </Grid>
  );
};
